import { render, staticRenderFns } from "./Popupvideo.vue?vue&type=template&id=18aad4e6&scoped=true&"
import script from "./Popupvideo.vue?vue&type=script&lang=js&"
export * from "./Popupvideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aad4e6",
  null
  
)

export default component.exports